module.exports = __webpack_public_path__ + "media/images/front/programs/icon-history-4ec4096422d1e23e74134d0a39bc7c3f.svg";